import React from 'react';
import { motion } from 'framer-motion';

/**
 * PaperFoldingLoader - Animated paper folding loader using icon.svg
 * Beautiful folding paper animation for loading states
 */
const PaperFoldingLoader = ({ isDarkMode = false, message = "Loading..." }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '20px',
      padding: '40px'
    }}>
      {/* Animated Paper Icon */}
      <motion.div
        animate={{
          rotateY: [0, 180, 360],
          scale: [1, 0.8, 1],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        style={{
          width: '80px',
          height: '80px',
          perspective: '1000px'
        }}
      >
        <motion.img
          src="/icon.svg"
          alt="Loading"
          animate={{
            rotateX: [0, 15, -15, 0],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          style={{
            width: '100%',
            height: '100%',
            filter: isDarkMode ? 'invert(1) brightness(1.2)' : 'none',
            transformStyle: 'preserve-3d'
          }}
        />
      </motion.div>

      {/* Loading Message */}
      <motion.div
        animate={{
          opacity: [0.5, 1, 0.5]
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        style={{
          fontFamily: 'Inter, sans-serif',
          fontSize: '14px',
          color: isDarkMode ? '#999' : '#666',
          textAlign: 'center'
        }}
      >
        {message}
      </motion.div>
    </div>
  );
};

export default PaperFoldingLoader;
